
import { Component, Prop, Vue } from "vue-property-decorator";
import DescribeData from "./describe.vue";
interface ValObj {
  color?: string;
  isEmpty?: boolean; // 用来控制是否为 评语是否为红色 true则为红色
  desc?: string; // 详细评语
  text?: string; // label对应的值
}

@Component({
  components: { DescribeData }
})
export default class Mandarin extends Vue {
  @Prop() valObj!: ValObj;
  isError = false;
}
